import { sendToMixpanel } from '../../mixpanel';

const trackShowMoreReviews = (): void => {
  sendToMixpanel('Click Show More Reviews - RMA');
};

export default trackShowMoreReviews;
